import { format, parseISO } from "date-fns";

// Os limites do período vêm em UTC e são inclusivos (from = 00:00:00.000Z,
// to = 23:59:59.999Z). Formatar o instante em horário local jogaria o `from`
// para o dia anterior no fuso do Brasil, então só a parte de data é
// interpretada. Há teste de regressão para isso.
const formatDateInUtc = isoInstant =>
  format(parseISO(isoInstant.slice(0, 10)), "dd/MM/yyyy");

export const formatPeriod = period => {
  if (!period?.from || !period?.to) return null;
  return `${formatDateInUtc(period.from)} a ${formatDateInUtc(period.to)}`;
};
